import { useApiConfigStore } from "@store/api_config";
import axios from "axios";

const publicApi = axios.create();
publicApi.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export const sessionsApi = {
  create: async (orgId: string): Promise<{ session_id: string }> => {
    const { data } = await publicApi.post(`/public/org/${orgId}/booking-sessions`, { org_id: orgId, step: 0 });
    return data;
  },

  update: async (
    orgId: string,
    sessionId: string,
    payload: { step?: number; status?: string; booking_id?: string; plate?: string; service?: string }
  ): Promise<void> => {
    await publicApi.patch(`/public/org/${orgId}/booking-sessions/${sessionId}`, payload);
  },

  getHistory: async (orgId: string, days = 30): Promise<
    { date: string; started: number; completed: number; abandoned: number }[]
  > => {
    const { data } = await publicApi.get(`/public/org/${orgId}/booking-sessions/history`, { params: { days } });
    return data;
  },

  getStats: async (orgId: string): Promise<{
    total: number;
    completed: number;
    abandoned: number;
    in_progress: number;
    conversion_rate: number;
    avg_abandon_step: number;
  }> => {
    const { data } = await publicApi.get(`/public/org/${orgId}/booking-sessions/stats`);
    return data;
  },

  getAnalytics: async (
    orgId: string,
    range: { days?: number; hours?: number }
  ): Promise<BookingAnalytics> => {
    const { data } = await publicApi.get(`/public/org/${orgId}/booking-sessions/analytics`, {
      params: range.hours ? { hours: range.hours } : { days: range.days ?? 30 },
    });
    return data;
  },
};

export type FunnelStep = { key: string; label: string; count: number; pct: number };
export type BookingLead = { name: string; email: string; phone: string; step: string; date: string };
export type BookingSeriesPoint = { bucket: string; visits: number; opens: number; completed: number };
export type BookingAnalytics = {
  visits: number;
  opens: number;
  completed: number;
  abandoned: number;
  conversion_rate: number;
  funnel: FunnelStep[];
  abandonment: FunnelStep[];
  leads: BookingLead[];
  series: BookingSeriesPoint[];
  hourly: boolean;
};
